// src/components/ToastMessage.js
import React, { useEffect, useState } from "react";

const ToastMessage = ({ message, type = "success", duration = 3000 }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  if (!show || !message) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        backgroundColor: type === "success" ? "#28a745" : "#dc3545",
        color: "white",
        padding: "10px 20px",
        borderRadius: "5px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        zIndex: 9999,
        fontWeight: "500",
      }}
    >
      {message}
    </div>
  );
};

export default ToastMessage;
